function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Grid_1_"
}, React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 26.2h614.4V350H91z"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(31.436 289.473)"
}, "20,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(67.394 350)"
}, "0"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(30.227 224.5)"
}, "40,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(30.904 159.675)"
}, "60,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(30.527 93.86)"
}, "80,000"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(25.47 36.626)"
}, "Median"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(33.67 52.226)"
}, "family"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(4.87 67.826)"
}, "income"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(59.47 67.826)"
}, "($)"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(89.854 378.753)"
}, "2009"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(153.157 378.753)"
}, "2010"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(231.917 378.753)"
}, "2011"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(307.373 378.753)"
}, "2012"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(384.201 378.753)"
}, "2013"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(460.373 378.753)"
}, "2014"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(537.792 378.753)"
}, "2015"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(614.314 378.753)"
}, "2016"), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Regular",
  fontSize: 13,
  transform: "translate(678.638 378.753)"
}, "2017"), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M167.8 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M244.6 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M321.4 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M398.2 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M475 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M551.8 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M628.6 26.2V350"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 220.5h614.9"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 285.2h614.9"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 155.7h614.9"
}), React.createElement("path", {
  fill: "none",
  stroke: "#8b93c4",
  d: "M91 91h614.9"
}), React.createElement("text", {
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13,
  transform: "translate(91 16.626)"
}, "Annual Median Family Income"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Lines",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round"
}, React.createElement("path", {
  strokeWidth: 2.867,
  d: "M91.2 228.4l76.7-4.4 76.8-4.1 76.8-2.4 76.8-2 76.8-3.1 76.8-2.9 76.7-5.8 76.8-7.6"
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M91.2 107.1l76.7-4.4 76.8-7.9 76.8-3 76.8-2.5 76.8-3.4 76.8-3.7 76.7-7.2 76.8-10.9",
  opacity: 0.6
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M91.2 230.2l76.7-1.9 76.8-3.5 76.8.1 76.8-1.4 76.8-2.9 76.8-3.8 76.7-5.1 77.8-7.4",
  opacity: 0.6
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M91.2 107.2l76.7-4 76.8-10.1 76.8-7.1 76.8-3.8 76.8-9.4 76.8-5.9 76.7-11.3 76.8-12.4"
}), React.createElement("path", {
  strokeWidth: 2.867,
  d: "M91.2 215.9l76.7-6.9 76.8-3.9 76.8-2.3h76.8l76.8-4.2 76.8-1.8 76.7-6.3 76.8-8.4",
  opacity: 0.6
}), React.createElement("path", {
  strokeDasharray: "3,6",
  d: "M91.2 166.5l76.7-4.8 76.8-6 76.8-2 76.8-1.5 76.8-2.9 76.8-2.4 76.7-6.1 76.8-8.9"
}));

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Labels",
  fill: "#fff",
  fontFamily: "Montserrat-Bold",
  fontSize: 13
}, React.createElement("text", {
  transform: "translate(717.116 44.893)"
}, "Asian"), React.createElement("text", {
  transform: "translate(717.116 66.59)"
}, "White"), React.createElement("text", {
  transform: "translate(717.116 214.77)"
}, "Other"), React.createElement("text", {
  transform: "translate(717.116 198.77)"
}, "Hispanic"), React.createElement("text", {
  transform: "translate(717.116 184.77)"
}, "Black"), React.createElement("text", {
  transform: "translate(718.523 134.474)"
}, "All"));

var SvgS4DesktopColors = function SvgS4DesktopColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "viz",
    x: 0,
    y: 0,
    viewBox: "0 0 800 400",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,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";
export { SvgS4DesktopColors as ReactComponent };